export const common = {
  'site.name': 'CSSBuy Spreadsheet',
  'site.domain': 'cssbuybr.wtf',
  'nav.home': 'Início',
  'nav.spreadsheet': 'Spreadsheet',
  'nav.guides': 'Guias',
  'nav.reviews': 'Avaliações',
  'nav.shipping': 'Envio',
  'nav.coupons': 'Cupons',
  'nav.safety': 'Segurança',
  'nav.about': 'Sobre',
  'nav.contact': 'Contato',
  'nav.shoppingGuide': 'Guia de Compras',
  'nav.products': 'Produtos',
  'lang.en': 'EN',
  'lang.pt': 'PT-BR',
  'lang.de': 'DE',
  'cta.explore': 'Explorar CSSBuy Spreadsheet',
  'cta.startGuide': 'Começar pelo Guia para Iniciantes',
  'cta.readMore': 'Ler Mais',
  'cta.viewAll': 'Ver Todos',
  'cta.buyNow': 'Comprar Agora',
  'cta.cssbuySpreadsheet': 'CSSBuy Spreadsheet',
  'cta.continueMain': 'Continuar para o Site Principal',
  'footer.disclaimer': 'Este site é um recurso informativo independente e não é afiliado ou endossado pela CSSBuy. As informações podem mudar. Sempre verifique os preços, disponibilidade, condições de envio, políticas e leis aplicáveis antes de comprar.',
  'footer.copyright': '© {year} CSSBuy Spreadsheet Guide. Todos os direitos reservados.',
  'footer.links': 'Links Rápidos',
  'footer.legal': 'Legal',
  'footer.privacy': 'Política de Privacidade',
  'footer.terms': 'Termos de Serviço',
  'footer.editorial': 'Política Editorial',
  'footer.sitemap': 'Mapa do Site',
  'hero.eyebrow': 'CSSBUY SPREADSHEET • GUIA INDEPENDENTE',
  'hero.h1': 'CSSBuy Spreadsheet — Encontre, Compare e Pesquise Produtos com Mais Facilidade',
  'hero.description': 'Explore o CSSBuy Spreadsheet, guias de compra, informações de envio, QC, armazém, avaliações e comparações em um único lugar.',
  'hero.secondary': 'Nosso objetivo é ajudar você a pesquisar produtos, entender custos e tomar decisões mais informadas antes de comprar.',
  'hero.trust': 'Guia independente • Conteúdo atualizado • Português, English e Deutsch • Foco em segurança',
  'spreadsheet.h2': 'CSSBuy Spreadsheet: seu ponto de partida para pesquisar produtos',
  'spreadsheet.description': 'O CSSBuy Spreadsheet organiza informações e links para facilitar a pesquisa de produtos. Use-o como ponto de partida e confirme sempre preços, disponibilidade, vendedores e condições atuais antes de comprar.',
  'spreadsheet.card1.title': 'Encontrar',
  'spreadsheet.card1.desc': 'Descubra produtos e categorias.',
  'spreadsheet.card2.title': 'Comparar',
  'spreadsheet.card2.desc': 'Compare informações antes de decidir.',
  'spreadsheet.card3.title': 'Verificar',
  'spreadsheet.card3.desc': 'Confira links, vendedores e QC quando disponíveis.',
  'spreadsheet.card4.title': 'Decidir',
  'spreadsheet.card4.desc': 'Confirme as informações atuais antes do pagamento.',
  'spreadsheet.cta': 'Ver CSSBuy Spreadsheet',
  'categories.h2': 'Explore o CSSBuy Spreadsheet por categoria',
  'categories.cta': 'Ver Todas as Categorias',
  'beginner.h2': 'Nunca usou CSSBuy? Comece aqui',
  'beginner.step1': 'Encontre — descubra produtos.',
  'beginner.step2': 'Pesquise — compare preços e informações.',
  'beginner.step3': 'Verifique — analise QC, políticas e custos.',
  'beginner.step4': 'Decida — confirme tudo antes do pagamento.',
  'beginner.cta': 'Ler Guia para Iniciantes',
  'review.h2': 'CSSBuy Review: vale a pena?',
  'review.description': 'Analise recursos, custos, envio, armazém, QC, vantagens, limitações e pontos de segurança antes de decidir.',
  'review.card1': 'CSSBuy Review',
  'review.card2': 'CSSBuy Shipping Cost',
  'review.card3': 'CSSBuy Warehouse',
  'review.card4': 'Is CSSBuy Legit?',
  'review.card5': 'CSSBuy Coupon',
  'review.card6': 'CSSBuy Discount Code',
  'review.cta': 'Ver Todas as Análises',
  'shipping.h2': 'CSSBuy Shipping Cost: entenda os custos',
  'shipping.desc': 'Peso, volume, destino, linha de envio, seguro e serviços adicionais podem afetar o preço final.',
  'shipping.table.factor': 'Fator',
  'shipping.table.impact': 'Impacto',
  'shipping.weight': 'Peso',
  'shipping.weightImpact': 'Pode aumentar o custo',
  'shipping.volume': 'Volume',
  'shipping.volumeImpact': 'Pode influenciar determinadas rotas',
  'shipping.destination': 'Destino',
  'shipping.destinationImpact': 'Valores variam por país',
  'shipping.line': 'Linha',
  'shipping.lineImpact': 'Tarifas variam',
  'shipping.insurance': 'Seguro',
  'shipping.insuranceImpact': 'Pode alterar o valor',
  'shipping.services': 'Serviços',
  'shipping.servicesImpact': 'Podem gerar custos adicionais',
  'shipping.cta': 'Ver Guia de Shipping Cost',
  'safety.h2': 'Segurança em primeiro lugar',
  'safety.card1': 'Verificar links',
  'safety.card2': 'Proteger conta',
  'safety.card3': 'Conferir preço final',
  'safety.card4': 'Analisar QC',
  'safety.card5': 'Entender envio',
  'safety.card6': 'Verificar regras alfandegárias',
  'safety.card7': 'Evitar sites suspeitos',
  'safety.card8': 'Não compartilhar dados sensíveis',
  'safety.cta': 'Visitar Safety Center',
  'trust.h2': 'Por que usar nosso guia?',
  'trust.point1': 'Informação organizada',
  'trust.point2': 'Conteúdo atualizado',
  'trust.point3': 'Comparações',
  'trust.point4': 'Multilíngue',
  'trust.point5': 'Independente',
  'final.h2': 'Pronto para explorar o CSSBuy Spreadsheet?',
  'final.desc': 'Comece pelo nosso guia principal e encontre recursos para pesquisar produtos, entender custos e comprar com mais informação.',
  'final.cta': 'Explorar CSSBuy Spreadsheet',
  'dropdown.label': 'Categorias',
  'pillar.h2': 'Guias e Recursos do CSSBuy',
  'pillar.desc': 'Explore nossos artigos principais detalhados sobre avaliações, envio, armazém, QC, cupons, segurança e mais.',
  'faq.h2': 'Perguntas Frequentes',
  'faq.q1': 'O que é CSSBuy Spreadsheet?',
  'faq.a1': 'O CSSBuy Spreadsheet é uma coleção organizada de links e informações de produtos para ajudar na pesquisa antes de comprar. Serve como ponto de partida para descoberta e comparação de produtos.',
  'faq.q2': 'O CSSBuy é seguro para usar?',
  'faq.a2': 'O CSSBuy é um serviço de agente de compras. Como qualquer plataforma, você deve verificar as informações atuais, conferir avaliações e seguir práticas de segurança antes de fazer compras. Sempre confirme preços e políticas antes de comprar.',
  'faq.q3': 'Como usar o CSSBuy Spreadsheet?',
  'faq.a3': 'Use o spreadsheet para navegar por categorias, encontrar produtos de interesse e comparar informações. Sempre verifique links atuais, informações do vendedor e preços diretamente na plataforma antes de comprar.',
  'faq.q4': 'Quais são os custos de envio do CSSBuy?',
  'faq.a4': 'Os custos de envio dependem do peso, volume, destino, linha de envio e serviços adicionais. Consulte nosso guia de envio para informações detalhadas sobre os fatores que afetam os preços.',
  'faq.q5': 'Como encontrar cupons CSSBuy?',
  'faq.a5': 'A disponibilidade de cupons muda frequentemente. Sempre verifique as promoções atuais na plataforma oficial ou nosso guia de cupons para as informações mais recentes verificadas.',
  'article.readTime': 'leitura de {minutes} min',
  'article.lastUpdated': 'Atualizado em: {date}',
  'article.author': 'Equipe CSSBuy Guide',
  'article.breadcrumbHome': 'Início',
  'article.relatedArticles': 'Artigos Relacionados',
  'article.toc': 'Índice',
  'article.quickAnswer': 'Resposta Rápida',
  'article.safetyNote': 'Sempre verifique a plataforma atual, página de pagamento, informações do vendedor, preços, condições de envio e leis aplicáveis antes de comprar.',
  'article.sources': 'Fontes e Verificação',
  'seo.keywords': 'CSSBuy spreadsheet, planilha CSSBuy, CSSBuy avaliação, CSSBuy frete, CSSBuy cupom, CSSBuy Brasil',
  'seo.metaDescription': 'Guia CSSBuy Spreadsheet — encontre, compare e pesquise produtos. Avaliações independentes, custos de envio, informações de armazém, guias de QC, cupons e dicas de segurança.',
  'seo.title': 'CSSBuy Spreadsheet — Encontre, Compare e Pesquise Produtos | cssbuybr.wtf',
  'category.shoes': 'Shoes',
  'category.hoodies': 'Hoodies/Sweaters',
  'category.tshirts': 'T-Shirts',
  'category.jackets': 'Jackets',
  'category.pants': 'Pants/Shorts',
  'category.headwear': 'Headwear',
  'category.sets': 'Sets',
  'category.underwear': 'Underwear/Underpants',
  'category.jersey': 'Jersey',
  'category.accessories': 'Accessories',
  'category.bags': 'Bags',
  'category.belts': 'Belts',
  'category.perfumes': 'Perfumes',
  'category.other': 'Other Stuff',
  'featuredProducts': {
    title: 'Produtos em Destaque',
    subtitle: 'Navegue por produtos selecionados da planilha CSSBuy — clique em qualquer item para ver detalhes e comprar no Kaspreadsheet.',
    viewAll: 'Ver Todos os Produtos',
  },
  'products': {
    heroTagline: 'Seleção Curada de Produtos',
    heroTitle: 'Produtos da Planilha CSSBuy',
    heroSubtitle: 'Navegue por mais de 100 produtos verificados da planilha CSSBuy. Filtre por categoria, compare preços e clique para comprar.',
    allCategories: 'Todas as Categorias',
    allTitle: 'Todos os Produtos',
    items: 'itens',
    noResults: 'Nenhum produto encontrado nesta categoria.',
    ctaTitle: 'Pronto para explorar mais?',
    ctaSubtitle: 'Visite o Kaspreadsheet para o catálogo completo com milhares de produtos verificados em todas as categorias.',
  },
};

export default common;